import { useCallback, useState } from "react";
import type { RRuleType } from "verdi-common/utils/RRuleLibrary";
import { MasterIndex } from "verdi-web-client/Models";
import { IrrigationEventProto } from "verdi-web-client/Models/Scheduling/IrrigationEventProto";

interface EditZoneEventInfo {
    eventId: IrrigationEventProto["id"];
    editEventParams: Partial<{
        zoneWateringPercentages: Record<string, number>;
        duration: number;
        rule: RRuleType;
        startTime: Date;
        zoneIrrigationOffsets: Record<string, number>;
    }>;
}

export const useEditZoneEvent = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const editZoneEvent = useCallback(async ({ eventId, editEventParams }: EditZoneEventInfo) => {
        setLoading(true);
        setError(null);
        try {
            const repeatingIrrigationEvent = MasterIndex.repeatingEvent.byID[eventId];
            if (!repeatingIrrigationEvent) {
                setError(new Error("Event not found"));
                return null;
            }
            await repeatingIrrigationEvent.edit(
                editEventParams.zoneWateringPercentages,
                editEventParams.duration,
                editEventParams.rule,
                editEventParams.startTime,
                editEventParams.zoneIrrigationOffsets,
            );

            return repeatingIrrigationEvent;
        } catch (errorEvent: unknown) {
            setError(errorEvent as Error);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        editZoneEvent,
        loading,
        error,
    };
};
